<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="fmt">A welcome addition to modern discussion of the Roman army officer Lucius Artorius Castus which seeks to place him within an appropriate timescale and very properly disputes the links that have been suggested between this ‘real’ Roman army officer and the later and very much more fictional King Arthur.</p>
<p class="fmr">Nick Higham historian and author of <em class="italic">King Arthur</em></p>
<p class="fmr"><em class="italic">The Making of the Legend</em>.</p>
<p class="fm">A fascinating investigation into the historical figure of Lucius Artorius Castus, Camp Prefect of VI Victrix based at York.</p>
<p class="fmr">Dave Grainger, legio VI Eboracum</p>
<p class="fm">Tony’s book provides a detailed look at the supposed connections between an obscure Roman army officer, Lucius Artorius Castus, the later legends of ‘King’ Arthur, and the alleged influence of Sarmatians posted to Britain in the late second century on their development. When Castus’s career is examined with the forensic detail provided, his role in Britain – a posting late in his career when he was well over the age for active service – turns out to have been administrative, hardly the stuff of which Arthurian legends were made. It also becomes clear that the so-called ‘Alano-Sarmatian hypothesis’ for the origins of much of the medieval tales about Arthur is based on evidence so insubstantial that it vanishes into the thin air from which it was plucked. A thoroughly worthwhile and timely demolition of one of the fringe theories about the Arthurian legends.</p>
<p class="fmr">Keith J. Fitzpatrick Matthews,</p>
<p class="fmr">North Hertfordshire Museum</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm.vue?bb83dd06